/** Portal list URL for self-service student exams */
export const STUDENT_EXAMS_LIST = "/students/exams";

export function isStudentOwnedExamFlow(pathname = "") {
  const p = pathname || "";
  return (
    p.startsWith(STUDENT_EXAMS_LIST) ||
    p.startsWith("/student/exam-guide") ||
    p.startsWith("/student/solve-exam")
  );
}

export function studentExamGuidePath(examId, name) {
  const q = name ? `?name=${encodeURIComponent(name)}` : "";
  return `/student/exam-guide/${examId}${q}`;
}

export function studentExamResultPath(examId, name) {
  const q = name ? `?name=${encodeURIComponent(name)}` : "";
  return `/exam-result/${examId}${q}`;
}

/** API error body from student exam endpoints (e.g. already answered). */
export function getStudentExamApiError(error) {
  const data = error?.response?.data;
  return {
    code: data?.code,
    message: data?.message || error?.message || "Something went wrong",
    alreadyAnswered:
      data?.code === 400 &&
      typeof data?.message === "string" &&
      /already answered/i.test(data.message),
  };
}
